// Observability seam — error + event reporting.
// Picks the impl at boot: `sentryObservability` if VITE_SENTRY_DSN is set,
// otherwise the console-only fallback. Single import surface for the rest
// of the app: `import { observability } from "@/lib/observability"`.

import { env } from "@/lib/env";
import { consoleObservability } from "./console";
import { initSentry, sentryObservability } from "./sentry";

export interface ObservabilityUser {
  id: string;
  email?: string;
  businessId?: string;
}

export interface Observability {
  captureError(error: unknown, context?: Record<string, unknown>): void;
  captureEvent(name: string, props?: Record<string, unknown>): void;
  setUser(user: ObservabilityUser | null): void;
}

if (env.VITE_SENTRY_DSN) {
  initSentry();
}

export const observability: Observability = env.VITE_SENTRY_DSN
  ? sentryObservability
  : consoleObservability;

export { consoleObservability, sentryObservability, initSentry };
